import { i18n } from "@/locales";
import dayjs, { Dayjs } from "dayjs";

function prependLeadingZero(element: number): string {
  if (element < 10) return `0${element}`;

  return String(element);
}

export function format(date: Date): string {
  if (!date) {
    return "";
  }
  const day = prependLeadingZero(date.getDate());
  const month = prependLeadingZero(date.getMonth() + 1);
  const year = date.getFullYear();
  const hours = prependLeadingZero(date.getHours());
  const minutes = prependLeadingZero(date.getMinutes());

  return `${day}.${month}.${year} ${hours}:${minutes}`;
}

export function formatRange(date: Date[]): string {
  const day1 = format(date[0]);
  const day2 = format(date[1]);

  return `${day1} - ${day2}`;
}

export function formatSAPDate(date: Date): string {
  const day = prependLeadingZero(date.getDate());
  const month = prependLeadingZero(date.getMonth() + 1);
  const year = date.getFullYear();
  const hours = prependLeadingZero(date.getHours());
  const minutes = prependLeadingZero(date.getMinutes());

  return `${year}-${month}-${day}T${hours}:${minutes}:00`;
}

export function formatUNIX(unix: string): string {
  let unixInt: number;
  try {
    unixInt = Number(unix);
  } catch (error: unknown) {
    return unix;
  }

  return dayjs(unixInt).format("DD.MM.YYYY");
}

export function getDateDiffText(date: Dayjs | number): string | undefined {
  //current date
  const current = dayjs();

  if (typeof date === "number") date = dayjs(date);

  // difference to current date
  const daysDifference = date.diff(current, "days") * -1;

  // today
  if (daysDifference == 0) return i18n.global.t("global.dates.today");
  // yesterday
  if (daysDifference == 1) return i18n.global.t("global.dates.yesterday");

  // before yesterday but still in this week
  if ((date.day() || 7) - 1 <= (current.day() || 7) - 1 && daysDifference < 7)
    return i18n.global.t("global.dates.lastDay", {
      day: i18n.global.t(`global.dates.weekdays.${date.day()}`),
    });

  const weekDiff = date.diff(current, "weeks") * -1;

  const endLastWeekDiff = (current.day() || 7) - 1;
  // last week
  if (weekDiff <= 1 && daysDifference <= endLastWeekDiff + 7)
    return i18n.global.t(`global.dates.lastWeek`, {
      day: i18n.global.t(`global.dates.weekdays.${date.day()}`),
    });

  // this month
  if (date.month() == current.month())
    return i18n.global.t(`global.dates.thisMonth`);

  // last month
  if (date.month() === current.month() - 1)
    return i18n.global.t(`global.dates.lastMonth`);

  // previous month
  if (date.month() === current.month() - 2)
    return i18n.global.t(`global.dates.previousMonth`);

  return i18n.global.t(`global.dates.longerTimer`);
}
